<template>
  <x-drawer v-bind="$attrs" title="用户详情" @close="close" @open="open">
    <div class="user-detail">
      <div class="title-micro">
        <i></i>
        <span>基础信息</span>
      </div>
      <ul class="info">
        <li>
          <div class="t1">姓名:</div>
          <div class="t2">{{ data.displayName||'-' }}</div>
        </li>
        <li>
          <div class="t1">手机号码:</div>
          <div class="t2">{{ data.mobile||'-' }}</div>
        </li>
        <li>
          <div class="t1">邮箱:</div>
          <div class="t2">{{ data.email||'-' }}</div>
        </li>
      </ul>
      <div class="title-micro">
        <i></i>
        <span>组织信息</span>
      </div>
      <ul class="organ-list">
        <OrganCard
          v-for="item in organList"
          :key="item.groupName"
          :data="item"
          :active="item.belongGroup==1"
        ></OrganCard>
      </ul>
    </div>
  </x-drawer>
</template>

<script>
import OrganCard from '@/views/common/organCard.vue'
export default {
  components: { OrganCard },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    top: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      organList: []
    }
  },
  created() {},
  methods: {
    open() {
      console.log(this.top)
      this.$api.config.getOrganSelect({ userId: this.data.id }).then((res) => {
        this.organList = res.data.map((item) => ({
          ...item,
          active: item.defaultGroup == 1,
          role: (item.roles || []).map((item) => item.roleName).join(','),
          dep: (item.deptGroups || []).map((item) => item.groupName).join(',')
        }))
      })

      // this.$api.user.getUserOrgan({ userId: this.data.id }).then((res) => {
      //   this.organList = res.data.map((item) => ({
      //     ...item,
      //     role: item.roles.map((item) => item.userDisplayName).join(','),
      //     dep: item.deptGroups.map((item) => item.groupName).join(',')
      //   }))
      // })
    },
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.user-detail {
  padding: 0 20px 30px 40px;
  .info {
    li {
      margin-top: 6px;
      display: flex;
      font-size: 14px;
      .t1 {
        width: 100px;
        flex-basis: 100px;
        color: #949494;
        text-align: right;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .t2 {
        margin-left: 16px;
        color: #595b5f;
        width: 320px;
        word-wrap: break-word;
      }
    }
  }
  .title-micro {
    margin-top: 26px;
  }
  .organ-list {
    .organ-card {
      width: 470px;
      margin-top: 20px;
      /deep/.text{
        width: 310px;
      }
    }
  }
}
</style>
